import { Feedback } from '@alife/next';

const MessageTip = {};
const config = {
    align: 'tc tc',
    offset: [0, 80],
    duration: 5000
};
const typeMap = {
    success: 'success',
    alert: 'prompt',
    error: 'error'
};

Object.keys(typeMap).forEach(type => {
    MessageTip[type] = content => {
        Feedback.toast[typeMap[type]]({
            ...config,
            content
        });
    };
});

export default MessageTip;
